module.exports = __webpack_public_path__ + "img/left-banner.0def9847.png";